import environmentConfig from './utils/configs';

// Get version from environment or fallback to application version
const appVersion = import.meta.env.VITE_SENTRY_RELEASE || '0.0.0';
const config = {
    EVENT_NAMESPACE: 'beststart-winz.portal',
    audience: 'beststart-winz.portal',
    gitBranch: null,
    version: appVersion,
    namespace: 'beststart-winz.portal',
    tag: 'beststart-winz.portal',
    env: import.meta.env.MODE,
    apiAuthUrl: environmentConfig.winzApiUrl,
    winzApiUrl: environmentConfig.winzApiUrl,
    LogLevel: environmentConfig.LogLevel || 0, // Default to Error if not set
    sentry: {
        dsn: "https://926eb42d56e40635ecca6f413eeadf37@o4509346579677184.ingest.de.sentry.io/4509347185426512",
    },
    authentication: {
        clientId:   environmentConfig.clientId,
        authority: environmentConfig.authority,
        redirectUri: window.location.hostname === "localhost.lambdatest.com" ? 'https://localhost.lambdatest.com:50329/login' : `${window.location.origin}/login`,
    },

};
export default config;